/* ============================================================
   RYVA · Carrito — indicador de oferta 2X1 (v8, oferta unificada)
   Una sola tarjeta verde para los 8 lentes individuales
   (GoldenDay, UltraFocus, CalmVision + 5 Drishti), reflejando
   la oferta 2x1 única — mezcla libre entre líneas.
   Se ancla como HERMANO de <drawer-cart> o <cart-page> (nunca
   adentro) y solo lee el carrito — jamás toca el DOM del tema.
   Cargado desde snippets/copy-toast.liquid (todo el sitio).
   i18n: textos desde window.RYVA_I18N (snippets/ryva-js-i18n.liquid).
   ============================================================ */
(function () {
  function RY(k, fb) {
    var d = window.RYVA_I18N;
    return (d && typeof d[k] === 'string' && d[k].length) ? d[k] : fb;
  }
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  var ALL = ['drishti-negro-amarillo', 'drishti-negro-naranja', 'drishti-gris-translucido-naranja', 'drishti-negro-rojo-vino', 'drishti-cristal-rojo-vino', 'ryva-morning-goldenday', 'ryva-afternoon-ultrafocus', 'ryva-night-calmvision'];
  var prevDone = { a: false };
  var renderTimer = null;
  var lastRender = 0;
  var expectRows = false;

  function injectCss() {
    if (document.getElementById('ryva-2x1-cart-css')) return;
    var st = document.createElement('style');
    st.id = 'ryva-2x1-cart-css';
    st.textContent =
      "#ryva-2x1-cart{font-family:'Poppins',sans-serif;display:flex;flex-direction:column;gap:8px}" +
      '#ryva-2x1-cart.r2x-drawer{margin:6px 16px 12px}' +
      '#ryva-2x1-cart.r2x-page{margin:0 0 16px}' +
      '#ryva-2x1-cart .r2c__row{display:flex;align-items:center;gap:11px;background:#e8f8ee;border-radius:10px;padding:13px 14px;transition:background .2s ease}' +
      '#ryva-2x1-cart .r2c__row.is-done{background:#dff5e8}' +
      '#ryva-2x1-cart .r2c__ic{width:22px;height:22px;flex:0 0 auto}' +
      '#ryva-2x1-cart .r2c__ic svg{display:block;width:22px;height:22px}' +
      '#ryva-2x1-cart .r2c__circle{fill:none;stroke:#0a0a0a;stroke-width:1.6}' +
      '#ryva-2x1-cart .r2c__fill{fill:#0a0a0a;transform-origin:center;transform:scale(0);transition:transform .35s cubic-bezier(.2,1.4,.4,1)}' +
      '#ryva-2x1-cart .r2c__tick{fill:none;stroke:#e8f8ee;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:14;stroke-dashoffset:14;transition:stroke-dashoffset .3s ease .25s}' +
      '#ryva-2x1-cart .is-done .r2c__fill{transform:scale(1)}' +
      '#ryva-2x1-cart .is-done .r2c__tick{stroke-dashoffset:0}' +
      '#ryva-2x1-cart .r2c__t1{font-size:12px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;color:#0a0a0a;line-height:1.35}' +
      '#ryva-2x1-cart .r2c__t2{display:block;font-size:10.5px;font-weight:400;color:#5f7a69;margin-top:2px;line-height:1.35}' +
      '#ryva-2x1-cart .r2c__row.pop{animation:r2cpop .45s cubic-bezier(.2,1.4,.4,1)}' +
      '@keyframes r2cpop{0%{transform:scale(.97)}55%{transform:scale(1.015)}100%{transform:scale(1)}}';
    document.head.appendChild(st);
  }

  function iconSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle class="r2c__circle" cx="12" cy="12" r="10"/><circle class="r2c__fill" cx="12" cy="12" r="10"/><path class="r2c__tick" d="M7.5 12.4l3 3 6-6.4"/></svg>';
  }
  function rowHtml(key, done, t1, t2) {
    return '<div class="r2c__row' + (done ? ' is-done' : '') + '" data-r2c="' + key + '">' +
      '<span class="r2c__ic">' + iconSvg() + '</span>' +
      '<span><span class="r2c__t1">' + esc(t1) + '</span><span class="r2c__t2">' + esc(t2) + '</span></span></div>';
  }
  function countFor(items, handles) {
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      if (handles.indexOf(items[i].handle) !== -1) n += items[i].quantity;
    }
    return n;
  }
  function rowsFor(key, count) {
    if (count <= 0) return '';
    var free = Math.floor(count / 2);
    if (count % 2 === 1) {
      var t1 = free === 0
        ? RY('cart_add_another', 'Agrega otro par — el 2.º es GRATIS')
        : RY('cart_add_one_more', 'Agrega 1 más — también sale GRATIS');
      return rowHtml(key, false, t1, RY('cart_mix_note', 'Combina cualquier lente Ryva · Descuento automático'));
    }
    var t1d = free === 1
      ? RY('cart_second_free', '¡Tu 2.º lente va GRATIS!')
      : RY('cart_n_free', '¡{n} lentes GRATIS en tu pedido!').replace('{n}', free);
    return rowHtml(key, true, t1d, RY('cart_applied', 'Oferta 2X1 aplicada · Lentes Ryva'));
  }

  function getCartRoot() {
    return document.querySelector('cart-drawer-component drawer-cart') || document.querySelector('cart-page');
  }

  function mount(cart) {
    var dc = getCartRoot();
    var n = countFor(cart.items, ALL);
    var rowsMarkup = rowsFor('a', n);
    expectRows = !!rowsMarkup;

    var node = document.getElementById('ryva-2x1-cart');
    if (!rowsMarkup) { if (node) node.remove(); return; }
    if (!node) {
      if (!dc || !dc.parentElement) return;
      node = document.createElement('div');
      node.id = 'ryva-2x1-cart';
      node.className = dc.tagName === 'CART-PAGE' ? 'r2x-page' : 'r2x-drawer';
      dc.parentElement.insertBefore(node, dc);
    }
    if (node.innerHTML !== rowsMarkup) {
      node.innerHTML = rowsMarkup;
      var row = node.querySelector('[data-r2c="a"]');
      var done = !!(row && row.classList.contains('is-done'));
      if (row && done && !prevDone.a) row.classList.add('pop');
      prevDone.a = done;
    }
  }

  function render() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        injectCss();
        mount(cart);
        lastRender = Date.now();
      })
      .catch(function () {});
  }
  function scheduleRender() {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(render, 350);
  }

  /* escuchar cambios del carrito (solo lectura, sin tocar el tema) */
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) { p.then(scheduleRender, function () {}); }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('loadend', scheduleRender);
    }
    return _open.apply(this, arguments);
  };
  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart:afterCartLoad'].forEach(function (ev) {
    document.addEventListener(ev, scheduleRender);
  });
  var mo = new MutationObserver(function () {
    if (Date.now() - lastRender < 900) return;
    if (expectRows && !document.getElementById('ryva-2x1-cart')) scheduleRender();
  });

  function start() {
    render();
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();